export const searchFilter = {
  element: '#studio > div.page-content > div.filters > div.search-filter',
  popover: {
    title: 'Search Filter',
    description: 'Easily find your signature by searching for a specific signature name',
    side: 'bottom',
    align: 'start'
  }
};

export const archivedFilter = {
  element: '#toggle-filter',
  popover: {
    title: 'Include Archived Filter',
    description: `
      Use the toggle filter to show and hide archived signatures.
    `,
    side: 'bottom',
    align: 'start'
  }
};

export const sortingFilter = {
  element: '#sort-filter',
  popover: {
    title: 'Sorting Filter',
    description: `
      Use the sorting filter to organize your signatures by <strong>Last Updated</strong>, <strong>Name</strong>, or <strong>Status</strong>.
      <br/><br/>  
      <strong>Note</strong>
      <br/>
      Use the <code><i class="os-icon-arrow-up"></i></code> and <code><i class="os-icon-arrow-down"></i></code> icons to toggle between ascending and descending order.
    `,
    side: 'bottom',
    align: 'start'
  }
};
